import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import * as actions from "../../stores/actionsList"


class MyPortals extends Component {
    state = {
        portals: [
            { label: '{{lang}}Messenger', notif: 5, window: 'messenger', icon: '/assets/icons/portals/folder2.svg', description: '{{lang}}Keep in touch with people matter to you' },
            { label: '{{lang}}Drive', window: 'drive', icon: '/assets/icons/portals/drivetest.svg', description: '{{lang}}Keep your files safe and secure in Yonnect cloud' },
            { label: '{{lang}}Rooms', window: 'rooms', icon: '/assets/icons/portals/roomtest.png', description: '{{lang}}Video and voice rooms. Enjoy custom rooms' },
            { label: '{{lang}}Desk', notif: 20, window: 'desk', icon: '/assets/icons/portals/desktest.svg', description: '{{lang}}Track your tasks and plans all in yonnect Desk' },
            { label: '{{lang}}Email', window: 'email', icon: '/assets/icons/portals/mailtest.png', description: '{{lang}}Enjoy social connection with people and ideas' },
            { label: '{{lang}}Notebook', window: 'notebook', icon: '/assets/icons/Notebook.svg', description: '{{lang}}Keep all your notes and whiteboards here' },
            // { label: '{{lang}}Calendar', window: 'calendar', icon: '/assets/icons/Notebook.svg', description: '{{lang}}check your calendar' },
        ],
    }
    componentDidMount() {
    }
    render() {

        return (
            <div className="w-100 no-scrollbar px-2 tower-body bg-white h-100" style={{ left: 0, width: '100%', }}>
                <button className='px-1 flexc pt-3 pb-3' onClick={() => this.props.changeStage('Home')}>
                    <img src='/assets/icons/tower/arrow-left-gray.svg' width={'22px'} className='rtl-button' style={{ cursor: 'pointer' }} />
                    <p className="font-size-15 main-c2">{translate('Portals')}</p>
                </button>
                {this.state.portals.map((item, index) => {
                    return (
                        <button className="flex-1 w-100" >
                            <div className=" px-2 pt-2 pb-3 d-flex w-100" onClick={() => { this.props.addNewWindow(item.window); this.props.toggle() }}>
                                <img className="mt-1" src={item.icon} height={40} />
                                <div className="mld-3 w-100">
                                    <div className="flexcb w-100">
                                        <p className="text-semibold text-normal ">{checkTranslation(item.label)}</p>
                                        {item.notif && (
                                            <div className="portal-notification flexcc ">{item.notif}</div>
                                        )}
                                    </div>
                                    <p className="text-smallest mt-0" style={{ textAlign: 'start' }}>{checkTranslation(item.description)}</p>
                                </div>

                            </div>
                        </button>
                    )
                })}
            </div>

        )
    }
}
const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif, relations: state.relations });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(MyPortals);